import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MerchantOnboardingComponent } from '../../components/merchant/merchant-onboarding/merchant-onboarding.component';
import { MerchantTableViewComponent } from '../../components/merchant/merchant-table-view/merchant-table-view.component';
import { AccessManager } from '../../components/ui/access-manager/access-manager';
import { TableView } from '../../components/ui/filterable-table/tableView';
import { UIErrorHandler } from '../../core/uiErrorHandler';
import { StorageService } from '../../core/storage/storageService';
import { MerchantService } from '../../models/merchant/merchantService';
import { Merchant } from '../../models/merchant/merchant';
import { BasePage } from '../BasePage';

@Component({
  selector: 'app-merchants-page',
  templateUrl: './merchants-page.component.html',
  standalone: false,
})
export class MerchantsPageComponent extends BasePage {
  @ViewChild('onboardingForm') onboardingForm:
    | MerchantOnboardingComponent
    | undefined;
  @ViewChild('merchantTable') merchantTableControl:
    | MerchantTableViewComponent
    | undefined;

  namespace: string = AccessManager.AUTH_SELECT_ALL_MERCHANTS;
  canCreateMerchants: boolean = false;

  helpContext1: string = 'helpContext1';

  merchantTableOptions: any = {
    selectAction: 'expand',
  };

  isEditable: boolean = false;
  doOnboard: boolean = false;
  allowAddLocation: boolean = false;

  //selectedIdObserver:Observable<any> | null = null;
  //selectedId:string | null = null;

  merchant: Merchant | undefined;
  tableView: any;

  constructor(
    private merchantService: MerchantService,
    private storageService: StorageService,
    private router: Router,
    private uiErrorHandler: UIErrorHandler,
    private access: AccessManager,
  ) {
    super();

    this.tableView = new TableView(MerchantTableViewComponent);

    this.access
      .getUserAccess([AccessManager.AUTH_INSERT_MERCHANTS])
      .then((accessRecord) => {
        this.allowAddLocation = this.canCreateMerchants =
          accessRecord[AccessManager.AUTH_INSERT_MERCHANTS] == true;
      });
  }

  ngAfterViewInit() {
    let myAccount = this.storageService.getMyAccount();

    if (myAccount) {
      this.merchantTableOptions.businessId = myAccount.id;
    }

    this.merchantTableOptions.selectRoute = 'merchant/account';
    this.merchantTableControl?.setOptions(this.merchantTableOptions);
  }

  public handleMerchantOnboarded(merchantId: string) {
    this.merchantService
      .getMerchantById(merchantId)
      .then((merch) => {
        //let merchant: Merchant = new Merchant(merch);
        this.storageService.setSelectedLocation(merch);
        this.router.navigateByUrl('merchant/account');
        //this.merchant = merch;
        //this.doOnboard = false;
        //window.scrollTo(0, 0);
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  //public setMerchantDatasource(dataSource: MatTableDataSource<Merchant>) {
  //  this.merchantDataSource = dataSource;
  //}

  public clearMerchantSelection() {
    this.storageService.removeSelectedLocation();
    this.merchant = undefined;
  }

  public btnNewMerchant_click() {
    this.doOnboard = true;
  }

  public btnCancelOnboard_click() {
    this.doOnboard = false;

    this.onboardingForm?.reset();
  }

  /*
  public setCustomerDataSource(dataSource: MatTableDataSource<Customer>) {
    this.customerDataSource = dataSource;
  }

  public handleCustomerSelected(customer: Customer) {
    this.customer = customer;
  }

  public clearCustomerSelection() {
    this.customer = undefined;
  }
  */
}
